import ToggleOption from "./ToggleOption";

// ── Table mode constants (mirrored from index.jsx for toggle active checks) ───
const fixedRowsFixedColumns     = "fixedRowsFixedColumns";
const fixedRowsDynamicColumns   = "fixedRowsDynamicColumns";
const dynamicRowsFixedColumns   = "dynamicRowsFixedColumns";
const dynamicRowsDynamicColumns = "dynamicRowsDynamicColumns";

const TableTypeToggles = ({
  tableMode,
  onSelectFixedRows,
  onSelectDynamicRows,
  onSelectFixedColumns,
  onSelectDynamicColumns,
}) => {
  const isFixedRows   = tableMode === fixedRowsFixedColumns   || tableMode === fixedRowsDynamicColumns;
  const isDynamicRows = tableMode === dynamicRowsFixedColumns || tableMode === dynamicRowsDynamicColumns;

  return (
    <div className="mb-4">
      <div className="row g-3">
        {/* Row Type */}
        <div className="col-md-6">
          <label className="form-label fw-medium text-dark mb-2 small">Row Type</label>
          <div className="d-flex gap-2">
            <ToggleOption
              active={isFixedRows}
              onClick={onSelectFixedRows}
              icon="fa-th-list"
              label="Fixed Rows"
            />
            <ToggleOption
              active={isDynamicRows}
              onClick={onSelectDynamicRows}
              icon="fa-random"
              label="Dynamic Rows"
            />
          </div>
        </div>

        {/* Column Type */}
        <div className="col-md-6">
          <label className="form-label fw-medium text-dark mb-2 small">Column Type</label>
          <div className="d-flex gap-2">
            <ToggleOption
              active={tableMode === fixedRowsFixedColumns || tableMode === dynamicRowsFixedColumns}
              onClick={onSelectFixedColumns}
              icon="fa-th-list"
              label="Fixed Columns"
            />
            <ToggleOption
              active={tableMode === fixedRowsDynamicColumns || tableMode === dynamicRowsDynamicColumns}
              onClick={onSelectDynamicColumns}
              icon="fa-random"
              label="Dynamic Columns"
            />
          </div>
          {tableMode === dynamicRowsDynamicColumns && (
            <small className="d-block text-muted mt-1">
              <i className="fas fa-info-circle me-1"></i>
              Data owner will define both rows &amp; columns at entry time.
            </small>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableTypeToggles;
